import { render, staticRenderFns } from "./PostMediaModal.vue?vue&type=template&id=66e44d94&lang=pug&"
import script from "./PostMediaModal.vue?vue&type=script&lang=js&"
export * from "./PostMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports